import type { Job, Season } from "@mysnowscape/snow-lib";
import type { RouteBuilderProperty } from "../../../../../types/routeBuilder";

export const DEFAULT_SERVICE_TIME_MINUTES = 60;

export function initialPropertyServiceTime(
  job: Pick<Job, "landscape" | "snow"> & {
    estimatedServiceTimeSeconds?: number;
  },
  season: Season,
): Pick<
  RouteBuilderProperty,
  "estimatedServiceTimeSeconds" | "serviceTimeSource"
> {
  // Full jobs store estimates per season; the slim projection stores them flat.
  const estimatedServiceTimeSeconds =
    job[season]?.estimatedServiceTimeSeconds ?? job.estimatedServiceTimeSeconds;
  return estimatedServiceTimeSeconds == null
    ? {
        estimatedServiceTimeSeconds: DEFAULT_SERVICE_TIME_MINUTES * 60,
        serviceTimeSource: "default",
      }
    : { estimatedServiceTimeSeconds, serviceTimeSource: "historical" };
}

export function withDefaultServiceTime(
  property: RouteBuilderProperty,
  minutes = DEFAULT_SERVICE_TIME_MINUTES,
): RouteBuilderProperty {
  return property.serviceTimeSource === "default"
    ? { ...property, estimatedServiceTimeSeconds: minutes * 60 }
    : property;
}

export function applyDefaultServiceTime(
  properties: RouteBuilderProperty[],
  minutes = DEFAULT_SERVICE_TIME_MINUTES,
): RouteBuilderProperty[] {
  return properties.map((property) =>
    withDefaultServiceTime(property, minutes),
  );
}

export function selectGenerationProperties<
  T extends Pick<RouteBuilderProperty, "jobId">,
>(properties: T[], excludedPropertyIds: string[] = []): T[] {
  const excluded = new Set(excludedPropertyIds);
  return properties.filter((property) => !excluded.has(property.jobId));
}
